import type { Provider } from "../../shared/types";

export interface ProviderMeta {
  id: Provider;
  label: string;
  loginUrl: string;
  glyph: string;
  color: string;
}

export const PROVIDERS: ProviderMeta[] = [
  { id: "microsoft", label: "Microsoft", loginUrl: "/auth/login", glyph: "M", color: "#0f6cbd" },
  { id: "google", label: "Google", loginUrl: "/auth/google/login", glyph: "G", color: "#ea4335" },
  // IMAP has no OAuth redirect — reconnect opens the credentials dialog instead.
  { id: "imap", label: "IMAP", loginUrl: "", glyph: "@", color: "#5a6b7b" },
];

export function providerMeta(id: string): ProviderMeta {
  return PROVIDERS.find((p) => p.id === id) ?? PROVIDERS[0]!;
}
